<template>
  <div>
    <b-card class="mt-4" title="Użytkownicy systemu">
      <div v-show="!isLoaded">
        <Loading ref="loadingSpinner"></Loading>
      </div>
      <div v-show="isLoaded">
        <div class="row pt-1 pb-1">
          <div class="col-1 font-weight-bold">Id</div>
          <div class="col-4 font-weight-bold">Nazwa</div>
          <div class="col-4 font-weight-bold">Role</div>
          <div class="col-3 font-weight-bold">Akcje</div>
        </div>

        <div
          class="row pt-1 pb-1 border-bottom"
          v-for="user in users"
          :key="user.id"
        >
          <div class="col-1">{{ user.id }}</div>
          <div class="col-4">{{ user.name }}</div>
          <div class="col-4">
            <ul style="list-style-type: none">
              <li v-for="role in user.roles" :key="role.id">
                {{ role.name }}
              </li>
            </ul>
          </div>
          <div class="col-3 div-icons-area">
            <span
              v-b-tooltip.hover
              title="Zmień hasło"
              @click="OpenChangePasswordModal(user)"
            >
              <i class="fas fa-key"></i>
            </span>
            <span>
              <i
                class="fas fa-address-card"
                v-b-tooltip.hover
                @click="OpenChangeRolesModal(user)"
                title="Zmień uprawnienia"
              ></i>
            </span>
          </div>
        </div>
        <SetNewPassword :user="selectedUser"></SetNewPassword>
        <ChangeRoles
          @UserRolesChanged="getData()"
          :user="selectedUser"
        ></ChangeRoles>
      </div>
    </b-card>
  </div>
</template>

<script>
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import Loading from "../../Common/Loading";
import UserService from "../../../services/user.service";
import SetNewPassword from "../Modals/User/SetNewPassword";
import ChangeRoles from "../Modals/User/ChangeRoles";

export default {
  components: { Loading, SetNewPassword, ChangeRoles },
  mixins: [urlConfig, toastr],
  mounted() {
    this.getData();
    this.$store.dispatch("getUserFormData");
  },
  data() {
    return {
      selectedUser: {},
      users: [],
      isLoaded: false,
    };
  },
  methods: {
    getData() {
      var that = this;
      this.isLoaded = false;
      UserService.getUsersList()
        .then((res) => {
          this.users = res.data;
          this.isLoaded = true;
        })
        .catch((e) => {
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        });
    },
    OpenChangePasswordModal(user) {
      this.selectedUser = user;
      this.$bvModal.show("SetNewPassword");
    },
    OpenChangeRolesModal(user) {
      this.selectedUser = user;
      this.$bvModal.show("ChangeRoles");
    },
  },
};
</script>